<template>
    <div>
        <modal-share-house class="download-app-modal" :display="modalStatus.downloadApp" @modalStatus="closeModal" >
            <div class="download-app-modal-wrap">
                <div class="content">
                   您還不是飛豬會員，立刻下載APP註冊成為會員
                    <vue-qrious class="qrcode" :value="hostUrl"  :size="size" level="L"/>
                </div>
            </div>
        </modal-share-house>
    </div>
</template>
<script>
import ModalShareHouse from '@/components/widge/ModalShareHouse.vue';
import VueQrious from 'vue-qrious'
import { mapGetters } from 'vuex'
import { 
    baseWebUrl,
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            size: 188,
        }
    },
    // mounted() {
    //     if(this.modalStatus.downloadApp){
    //         this.$analytics.logEvent('Qrcode下載', { screen_name: 'Qrcode下載'})
    //     }
    // },
    methods: {
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'downloadApp'})
        },
    },
    computed: {
        hostUrl: function () {
            return baseWebUrl + '?shareHouseItem=1&houseCid='+this.houseId
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            appUrl: 'GET_APP_URL',
            houseId: 'GET_SHARE_HOUSE_ID',
        })
    },
    components: {
        ModalShareHouse,
        'vue-qrious': VueQrious,
    }
}
</script>
<style lang="scss" scoped>
    #modal.download-app-modal{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 480px;
            height: 475px;
            padding: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            // .cancle{
            //     top: 32px;
            //     right: 32px;
            //     img{
            //         width: auto;
            //     }
            // }
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .download-app-modal-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        width: 384px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        font-size: 24px;
                        font-weight: 600;
                        line-height: 1.5;
                        .qrcode{
                            margin-top: 38px;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        #modal.download-app-modal{
            .modal-content{
                width: 284px;
                height: 230px;
                .detail{
                    .download-app-modal-wrap{
                        .content{
                            width: 244px;
                            font-size: 16px;
                            margin-top: 20px;
                            .qrcode{
                                width: 100px;
                                margin-top: 18px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/downloadApp.vue